export {
  default as resetEditorContents,
} from './modifiers/resetEditorContents';
